import { defineNuxtPlugin } from '#imports';
import { FOOTNOTE_ATTR } from '@i22team/rocket';
import { openFootnote } from '~/composables/footnote';

// One delegated listener for all footnote buttons rendered via `replaceFootnotes()` + v-html.
export default defineNuxtPlugin(() => {
  document.addEventListener('click', (e) => {
    const target = (e.target as HTMLElement | null)?.closest<HTMLElement>(`[${FOOTNOTE_ATTR}]`);
    const id = target?.getAttribute(FOOTNOTE_ATTR);
    if (!id) return;
    e.preventDefault();
    e.stopPropagation();
    openFootnote(id);
  });
});
